"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@chakra-ui/react");
var _excluded = ["children", "label", "inputId", "helperText", "errorMessage", "isFieldset", "isOptional", "customRequiredText"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FormControl = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    label = _ref.label,
    inputId = _ref.inputId,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isFieldset = _ref.isFieldset,
    isOptional = _ref.isOptional,
    customRequiredText = _ref.customRequiredText,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react2.FormControl, (0, _extends2["default"])({}, props, {
    ref: ref,
    as: isFieldset ? 'fieldset' : 'div',
    borderWidth: "0"
  }), label && /*#__PURE__*/_react["default"].createElement(_react2.FormLabel, {
    color: "gray.600",
    fontWeight: "semibold",
    marginBottom: helperText ? 0 : 1,
    fontSize: "sm",
    htmlFor: inputId,
    as: isFieldset ? 'legend' : 'label',
    requiredIndicator: props !== null && props !== void 0 && props.isRequired && customRequiredText ? /*#__PURE__*/_react["default"].createElement(_react2.Text, {
      marginLeft: 1,
      as: "span",
      variant: "caption",
      color: "text.secondary.light"
    }, customRequiredText) : null,
    optionalIndicator: isOptional && !(props !== null && props !== void 0 && props.isRequired) ? /*#__PURE__*/_react["default"].createElement(_react2.Text, {
      marginLeft: 1,
      as: "span",
      variant: "caption",
      color: "text.secondary.light"
    }, "Optional") : null
  }, label), helperText && /*#__PURE__*/_react["default"].createElement(_react2.FormHelperText, {
    color: "gray.600",
    marginBottom: 1,
    fontSize: "xs"
  }, helperText), children, /*#__PURE__*/_react["default"].createElement(_react2.FormErrorMessage, {
    color: "error",
    mt: 1,
    fontSize: "xs"
  }, errorMessage));
});
FormControl.propTypes = {
  inputId: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  children: _propTypes["default"].element,
  isFieldset: _propTypes["default"].bool,
  isOptional: _propTypes["default"].bool,
  isRequired: _propTypes["default"].bool,
  customRequiredText: _propTypes["default"].string
};
var _default = exports["default"] = FormControl;